module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": "slide"
    }
  }, [_c('modal', {
    attrs: {
      "open": _vm.isOpen,
      "title": _vm.createTitle
    },
    on: {
      "cancel": _vm.cancel,
      "save": _vm.save
    }
  }, [_c('field', {
    attrs: {
      "required": true,
      "errors": _vm.errors,
      "model": "external_form",
      "name": "name",
      "placeholder": "Form Name"
    },
    model: {
      value: (_vm.item.name),
      callback: function($$v) {
        _vm.$set(_vm.item, "name", $$v)
      },
      expression: "item.name"
    }
  }), _vm._v(" "), _c('field', {
    attrs: {
      "required": true,
      "errors": _vm.errors,
      "model": "external_form",
      "name": "language",
      "type": "radio",
      "collection": _vm.languageGetter,
      "defaultValue": _vm.currentLanguage
    },
    model: {
      value: (_vm.item.language),
      callback: function($$v) {
        _vm.$set(_vm.item, "language", $$v)
      },
      expression: "item.language"
    }
  }), _vm._v(" "), _c('field', {
    directives: [{
      name: "can",
      rawName: "v-can",
      value: ('projects.list'),
      expression: "'projects.list'"
    }],
    attrs: {
      "required": true,
      "errors": _vm.errors,
      "model": "external_form",
      "name": "project_id",
      "type": "select",
      "params": {
        no_i18n: true
      },
      "collection": _vm.projects
    },
    model: {
      value: (_vm.item.project_id),
      callback: function($$v) {
        _vm.$set(_vm.item, "project_id", $$v)
      },
      expression: "item.project_id"
    }
  })], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1dbd9b00","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/pages/external_forms/ExternalFormCreate.vue
// module id = 1831
// module chunks = 0